import { pathOr } from 'ramda';
import type { Nullable } from '../../../types';
import {
  SET_CURRENT_PATH,
  SET_INTERNAL_TRANSITION,
} from '../../constants/history';
import type { RootState } from '../../store';

export interface HistoryState {
  prevPath: Nullable<string>;
  currentPath: Nullable<string>;
  isExternal: boolean;
}

export const initialState: HistoryState = {
  prevPath: null,
  currentPath: null,
  isExternal: true,
};

const history = (
  state = initialState,
  { type, payload }: { type: string; payload: string }
): HistoryState => {
  if (type === SET_CURRENT_PATH) {
    if (!state.prevPath && !state.currentPath) {
      return { ...state, currentPath: payload };
    }

    return { ...state, prevPath: state.currentPath, currentPath: payload };
  } else if (type === SET_INTERNAL_TRANSITION) {
    return { ...state, isExternal: false };
  }

  return state;
};

export default history;

export const prevPathSelector = (state: RootState) =>
  pathOr(initialState.prevPath, ['app', 'history', 'prevPath'], state);

export const isExternalTransitionSelector = (state: RootState) =>
  pathOr(initialState.isExternal, ['app', 'history', 'isExternal'], state);
